interface IconProps {
  width: number;
  height: number;
}

export const EditIcon = ({ width, height }: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="30" height="30" rx="7" fill="#54B7DE" />
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="7"
        stroke="#54B7DE"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.72176 8.72176C7.97054 7.47299 9.83496 7 12.2226 7H14.0742C14.4841 7 14.8163 7.33225 14.8163 7.74209C14.8163 8.15194 14.4841 8.48418 14.0742 8.48418H12.2226C9.98134 8.48418 8.60549 8.93698 7.77124 9.77124C6.93698 10.6055 6.48418 11.9813 6.48418 14.2226V19.7774C6.48418 22.0187 6.93698 23.3945 7.77124 24.2288C8.60549 25.063 9.98134 25.5158 12.2226 25.5158H17.7774C20.0187 25.5158 21.3945 25.063 22.2288 24.2288C23.063 23.3945 23.5158 22.0187 23.5158 19.7774V17.9258C23.5158 17.5159 23.8481 17.1837 24.2579 17.1837C24.6678 17.1837 25 17.5159 25 17.9258V19.7774C25 22.165 24.527 24.0295 23.2782 25.2782C22.0295 26.527 20.165 27 17.7774 27H12.2226C9.83496 27 7.97054 26.527 6.72176 25.2782C5.47299 24.0295 5 22.165 5 19.7774V14.2226C5 11.835 5.47299 9.97054 6.72176 8.72176Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.5582 6.32666C24.533 5.32877 23.5036 4.8875 22.4693 5.02432C21.4767 5.15564 20.6752 5.79932 20.0363 6.49755L13.0824 14.1122L13.081 14.1137C12.8807 14.3342 12.7141 14.6225 12.5932 14.8908C12.4715 15.1607 12.3678 15.4729 12.3304 15.763L12.0155 18.6153L12.0153 18.6174C11.9404 19.3151 12.1412 19.9793 12.6114 20.4405C13.0853 20.9055 13.7546 21.0856 14.448 20.9622L17.1742 20.4805L17.1792 20.4796C17.4691 20.4263 17.7729 20.3012 18.0321 20.1578C18.2883 20.0161 18.5609 19.8234 18.7648 19.5939L25.7146 11.9838C26.3567 11.282 26.9246 10.4263 26.9931 9.41338C27.0639 8.3649 26.5909 7.337 25.5595 6.32795L25.5582 6.32666ZM20.2074 8.46483L21.1067 7.48004C21.6705 6.86399 22.1782 6.53001 22.6593 6.46636C23.0987 6.40824 23.7081 6.55395 24.546 7.36927C25.386 8.1913 25.5777 8.8281 25.5448 9.31513C25.5095 9.83774 25.2045 10.3889 24.644 11.0015L23.8837 11.834L23.4402 11.7914C21.6405 11.6184 20.5139 10.3427 20.2162 8.51912L20.2074 8.46483ZM19.0284 9.75577L14.1547 15.0926C14.0923 15.1614 14.0003 15.3028 13.9161 15.4896C13.8338 15.6722 13.7852 15.8393 13.7709 15.944L13.4586 18.773C13.4237 19.1 13.5233 19.2996 13.6269 19.4012C13.7266 19.499 13.9048 19.5817 14.1936 19.5302L16.9191 19.0486C17.0106 19.0314 17.1633 18.9769 17.3306 18.8844C17.5001 18.7906 17.6233 18.6916 17.6815 18.6256L17.69 18.616L22.686 13.1454C20.8242 12.7512 19.5855 11.435 19.0284 9.75577Z"
        fill="white"
      />
    </svg>
  );
};
